import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=f2747ccc&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2747ccc')) {
      api.createRecord('f2747ccc', component.options)
    } else {
      api.reload('f2747ccc', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=f2747ccc&", function () {
      api.rerender('f2747ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-215OP8wnjroKb/JS/imageCarousel.vue"
export default component.exports